// Copyright © 2025 The Things Industries B.V.

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Link from '@ttn-lw/components/link'

import Pill from '@console/components/pill/index.tti'

import PropTypes from '@ttn-lw/lib/prop-types'
import attachPromise from '@ttn-lw/lib/store/actions/attach-promise'

import { getLabel } from '@console/store/actions/labels.tti'

import { selectLabelById } from '@console/store/selectors/labels.tti'

const Label = ({ id, shouldLink }) => {
  const dispatch = useDispatch()
  const label = useSelector(state => selectLabelById(state, id))

  useEffect(() => {
    if (!label) {
      dispatch(attachPromise(getLabel(id)))
    }
  }, [dispatch, id, label])

  const pill = <Pill color={label.color} text={label.name ?? id} />

  if (shouldLink) {
    return <Link to={`/labels/${id}`}>{pill}</Link>
  }

  return pill
}

Label.propTypes = {
  id: PropTypes.string.isRequired,
  shouldLink: PropTypes.bool,
}

Label.defaultProps = {
  shouldLink: false,
}

export default Label
